import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  QbatAgencyAppData,
  QbatAgencyData,
  QbatContractorAppData,
  QbatContractorData,
  QbatCompareAppsResponse,
  QbatCompareSourceApp,
  QbatFifoGrouping,
  QbatFifoTableItem,
  QbatUser,
} from '@app/models';
import { environment } from '@env/environment';
import { map, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QbatService {
  constructor(private http: HttpClient) {}

  getQbatFifoTable(
    questionnaireTypeId: number,
    licenseClassifications?: number[],
    groupingId?: number
  ): Observable<QbatFifoTableItem[]> {
    return this.http.get<QbatFifoTableItem[]>(`${environment.apiUrl}/api/qbat/Qbat/GetQbatFifoTable`, {
      params: {
        questionnaireTypeId: questionnaireTypeId,
        licenseClassifications: licenseClassifications,
        groupingId: groupingId,
      },
    });
  }

  getQbatContractorTable(questionnaireTypeId: number): Observable<QbatContractorData[]> {
    return this.http.get<QbatContractorData[]>(
      `${environment.apiUrl}/api/qbat/Qbat/GetQbatContractorTable?questionnaireTypeId=${questionnaireTypeId}`
    );
  }
  getQbatContractorApps(vendorId: number, questionnaireTypeId: number): Observable<QbatContractorAppData> {
    return this.http.get<QbatContractorAppData>(
      `${environment.apiUrl}/api/qbat/Qbat/GetContractorApps?questionnaireTypeId=${questionnaireTypeId}&vendorId=${vendorId}`
    );
  }

  getQbatAgencyTable(questionnaireTypeId: number): Observable<QbatAgencyData[]> {
    return this.http.get<QbatAgencyData[]>(
      `${environment.apiUrl}/api/qbat/Qbat/GetQbatAgencyTable?questionnaireTypeId=${questionnaireTypeId}`
    );
  }
  getQbatAgencyApps(agencyId: number, questionnaireTypeId: number): Observable<QbatAgencyAppData> {
    return this.http.get<QbatAgencyAppData>(
      `${environment.apiUrl}/api/qbat/Qbat/GetAgencyApps?questionnaireTypeId=${questionnaireTypeId}&agencyId=${agencyId}`
    );
  }

  private fifoGroupings$: ReplaySubject<QbatFifoGrouping[]> = new ReplaySubject<QbatFifoGrouping[]>(1);
  private fifoGroupingsRetrieved = false;
  getFifoGroupings(): Observable<QbatFifoGrouping[]> {
    if (!this.fifoGroupingsRetrieved) {
      this.fifoGroupingsRetrieved = true;
      this.http
        .get<QbatFifoGrouping[]>(`${environment.apiUrl}/api/qbat/Qbat/GetFifoGroupings`)
        .subscribe(this.fifoGroupings$);
    }
    return this.fifoGroupings$.asObservable();
  }

  private qbatUsers$: ReplaySubject<QbatUser[]> = new ReplaySubject<QbatUser[]>(1);
  private qbatUsersRetrieved = false;
  getQbatUsers(): Observable<QbatUser[]> {
    if (!this.qbatUsersRetrieved) {
      this.qbatUsersRetrieved = true;
      this.http
        .get<QbatUser>(`${environment.apiUrl}/api/qbat/Qbat/GetQBATUsers`)
        .pipe(map(resp => (Array.isArray(resp) ? resp : [resp])))
        .subscribe(this.qbatUsers$);
    }
    return this.qbatUsers$.asObservable();
  }

  getCompareSourceApps(applicationId: number): Observable<QbatCompareSourceApp[]> {
    return this.http.get<QbatCompareSourceApp[]>(
      `${environment.apiUrl}/api/qbat/Qbat/GetCompareSourceApps?applicationId=${applicationId}`
    );
  }

  setManagedBy(managedById: number, applicationId?: number, vendorId?: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/qbat/Qbat/SetManagedBy`, {
      applicationId,
      vendorId,
      managedById,
    });
  }

  setCompareSourceApp(applicationId: number, comparableAppId: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/qbat/Qbat/SetCompareSourceApp`, {
      applicationId,
      comparableAppId,
    });
  }

  getCompareApps(applicationId: number): Observable<QbatCompareAppsResponse> {
    return this.http.get<QbatCompareAppsResponse>(
      `${environment.apiUrl}/api/qbat/Qbat/GetCompareApps?applicationId=${applicationId}`
    );
  }
}
